import { Reducer } from 'redux';
import { Actions } from '../actions/Actions';
import { UserContext } from '../Models/UserProfile';

// TODO: old state should be replacted with AuthenticationStatusState and action should be replaced with AuthenticationAction
export const reducer: Reducer<UserContext> = (
  oldState: UserContext = initialUserProfileState,
  action: any
): UserContext => {
  let newState: UserContext;
  switch (action.type) {
    case Actions.GET_USERPROFILE:
      newState = { ...oldState };
      break;
    case Actions.SET_USERPROFILE:
      newState = action.payload;
      break;
    default:
      newState = oldState;
      break;
  }
  return newState;
};

export const initialUserProfileState: UserContext = {
  displayName: '',
  flights: [],
  givenName: '',
  email: '',
  lastName: '',
  hasTeam: false,
  persona: '',
  displayColumns: {
    displayColumnOptions: [],
    owner: '',
    id: '',
  },
  areaPaths: [],
  views: [],
  userSettings: {},
  isUserExcluded: '',
  isUserInOrg: '',
  authorization:{
    TenantAuthorizations: []
  }
};

export const getUserProfile = (dispatch: any) => {
  dispatch({
    type: Actions.GET_USERPROFILE,
  });
};

export const setUserProfile = (payload: UserContext) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_USERPROFILE,
    payload,
  });
};
